/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Novel_Proud_Porpoise_ViewInputs */

const fr_novel_proud_porpoise_view = /** @type {(inputs: Novel_Proud_Porpoise_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 an`)
};

/**

* @param {Novel_Proud_Porpoise_ViewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const novel_proud_porpoise_view = /** @type {((inputs?: Novel_Proud_Porpoise_ViewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Novel_Proud_Porpoise_ViewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_novel_proud_porpoise_view(inputs)
});